export default __webpack_public_path__ + "static/media/happy-update.dd240f0d.png";